<template>
  <v-list dark>
    <div :class="{title: true, 'px-3': true, 'success--text': group.satisfied, 'error--text': !group.satisfied}">
      {{ group.mandatory ? 'Mandatory' : 'Conditional' }} Profile Requirement Group
    </div>

    <v-subheader>Candidate</v-subheader>

    <v-list-tile v-for="requirement in group.requirements" :class="{satisfied: requirement.satisfied, failed: !requirement.satisfied, requirement: true}" :key="requirement.id">
      <v-list-tile-avatar><v-icon>{{ requirement.satisfied ? 'mdi-check' : 'mdi-alert-outline' }}</v-icon></v-list-tile-avatar>
      <v-list-tile-content>
        <v-tooltip bottom max-width="50%">
          <v-list-tile-title slot="activator" v-html="requirement.reason" :class="reasonClass(requirement)" />
          <span v-html="requirement.reason" />
        </v-tooltip>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
  // Vue Component
  export default {
    props: { group: Object },
    methods: {
      reasonClass(requirement) {
        return {
          'success--text': requirement.satisfied,
          'error--text': !requirement.satisfied && requirement.mandatory,
          'warning--text': !requirement.mandatory && !requirement.satisfied
        }
      }
    }
  }
</script>
